import { Component } from '@angular/core';

@Component({
  selector: 'event-entry',
  templateUrl: 'event-entry.component.html',
})
export class EventEntryComponent {
  public title: string;
}



// WEBPACK FOOTER //
// ./src/modules/calendar/components/event-entry/event-entry.component.ts